import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["options", "interval"],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(
      this.chartData,
      Object.assign(
        {
          tooltips: {
            position: "nearest",
            mode: "index",
            intersect: false
          },
          scales: {
            xAxes: [
              {
                display: true,
                type: "time",
                time: {
                  parser: "DD.MM.YYYY HH:mm",
                  tooltipFormat: "DD.MM.YYYY HH:mm",
                  unit: "day",
                  unitStepSize: 1,
                  displayFormats: {
                    day: "DD.MM.YYYY"
                  }
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepSize: 10
                }
              }
            ]
          }
        },
        this.options
      )
    );
  }
};
